import React from "react";
import '../pages/Home.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from '../components/UserContext';
import { useContext } from "react";
import { useLocation } from 'react-router-dom';
import { isMobile } from "react-device-detect";
import LogRocket from 'logrocket';



function Home() {
    const location = useLocation();

    const navigate = useNavigate();

    const {Delegation, setDelegation, Agenda, setAgenda, Committee, setCommittee} = useContext(UserContext);

    const [blockMobile, setBlockMobile] = useState(false)

    const isLocalhost = window.location.hostname === 'localhost' || 
                        window.location.hostname === '127.0.0.1';

    useEffect(() => {
        if (isMobile) {
            setBlockMobile(true)
        }
    }, []);


    useEffect(() => {
        const { delegation, agenda, committee } = location.state || {};
        if (delegation, agenda, committee){
            localStorage.clear()
            document.getElementById("delegation").value = delegation;
            document.getElementById("agenda").value = agenda;
            document.getElementById("committee").value = committee;
            if (
                committee !== "DISEC" &&
                committee !== "ECOFIN" &&
                committee !== "UNHRC" &&
                committee !== "UNEP"
            ) {
                setShowOtherCommittee(true)
                document.getElementById("committee").value = "Other"
            }
        }
        if (localStorage.getItem("delegation") && localStorage.getItem("agenda") && localStorage.getItem("committee")) {
            setDelegation(localStorage.getItem("delegation"));
            setAgenda(localStorage.getItem("agenda"));
            setCommittee(localStorage.getItem("committee"));

            if (!isLocalhost) {
                LogRocket.identify(delegation, {
                    Delegation: localStorage.getItem("delegation"),
                    Committee: localStorage.getItem("committee"),
                });
            }
            navigate("/dashboard");
        }
    }, []);



    function handleSubmit() {
        localStorage.clear();
        const delegation = document.getElementById("delegation").value;
        const agenda = document.getElementById("agenda").value;
        let committee = document.getElementById("committee").value;

        if (committee === "") {
            alert("Please select a committee.");
            return;
        }

        if (committee === "Other") {
            committee = document.getElementById("otherCommittee").value;
            if (committee === "") {
                alert("Please enter a committee name.");
                return;
            }
        }

        if (delegation && agenda) {
            setDelegation(delegation);
            setAgenda(agenda);
            setCommittee(committee);
            async function fetchData() {
                try {
                    const netherlandsVariants = [
                        "netherlands",
                        "the netherlands",
                        "kingdom of the netherlands",
                        "kingdom of netherlands",
                        "netherland"
                    ];
                    let normalizedDelegation = delegation.trim().toLowerCase();
                    if (normalizedDelegation === "uk") {
                        normalizedDelegation = "united kingdom";
                    } else if (netherlandsVariants.includes(normalizedDelegation)) {
                        normalizedDelegation = "netherlands";
                    }

                    const response = await fetch('https://countries.dev/name/' + encodeURIComponent(normalizedDelegation));
                    if (!response.ok) {
                        throw new Error('Country not found');
                    }
                    let matches = await response.json();
                    // The name endpoint can return multiple partial matches (e.g. "india" also
                    // matches "British Indian Ocean Territory"), so prefer an exact name match.
                    let data = matches.find(c => c.name && c.name.toLowerCase() === normalizedDelegation) || matches[0];
                    let name = data.name;
                    if (name) {
                        localStorage.setItem("delegation", delegation);
                        localStorage.setItem("agenda", agenda);
                        localStorage.setItem("committee", committee);
                        if (!isLocalhost) {
                            console.log("LogRocket is not running on localhost, identifying user");
                            console.log("Delegation: ", delegation);
                            LogRocket.identify(delegation, {
                                Delegation: delegation,
                                Committee: committee,
                            });
                        }

                        navigate("/dashboard");
                    } 
                    else {
                        alert("Invalid delegation name. Please check the spelling.");
                    }

                } catch (error) {
                    console.error('Error fetching country data:', error);
                    alert("Error fetching country data. Please check the delegation name.");
                }
            }
            fetchData();

        } else {
            alert("Please fill in all fields.");
            return;
        }
        
    }

    const [showOtherCommittee, setShowOtherCommittee] = useState(false);

    useEffect(() => {
        const { delegation, agenda, committee } = location.state || {};

        if (showOtherCommittee) {
            if (committee) {
                document.getElementById("otherCommittee").value = committee
            }
        }
    },[showOtherCommittee])

    function handleCommitteeChange(e) {
        if (e.target.value === "Other") {
            setShowOtherCommittee(true);
        } else {
            setShowOtherCommittee(false);
        }
    }


    return (
        <>
        {!blockMobile && <>
            <div className="homepage">
                <header>
                    <div className="committees">
                        <div className="committee">
                            <img src={process.env.PUBLIC_URL + "/icons/disec.png"} alt="DISEC" />
                            <span>DISEC</span>
                        </div>
                        <div className="committee">
                            <img src={process.env.PUBLIC_URL + "/icons/ecofin.png"} alt="ECOFIN" />
                            <span>ECOFIN</span>
                        </div>
                        <div className="committee">
                            <img src={process.env.PUBLIC_URL + "/icons/unhrc.png"} alt="UNHRC" />
                            <span>UNHRC</span>
                        </div>
                        <div className="committee">
                            <img src={process.env.PUBLIC_URL + "/icons/unep.png"} alt="UNEP" />
                            <span>UNEP</span>
                        </div>
                    </div>
                </header>

                <main>
                    <h1>
                         Delegate <span className="highlight">AI</span>
                    </h1>
                    <p className="subtitle">Prepare for MUNs with AI</p>
                    <div className="form">
                        <input type="text" placeholder="Delegation" id="delegation" />
                        <input type="text" placeholder="Agenda" id="agenda" />
                        <select id="committee"  className="committee_select" onChange={handleCommitteeChange}>
                            <option value="">Select Committee</option>
                            <option value="DISEC">DISEC</option>
                            <option value="ECOFIN">ECOFIN</option>
                            <option value="UNHRC">UNHRC</option>
                            <option value="UNEP">UNEP</option>
                            <option value="Other">Other</option>
                        </select>
                        {showOtherCommittee && (
                            <input
                                type="text"
                                placeholder="Enter committee name"
                                id="otherCommittee"
                            />
                        )}
                        <button type="button" onClick={handleSubmit}>Get Started</button>
                    </div>
                </main>
            </div>
        </>}
        {blockMobile && <>
            <div className="block_page">
                <img className="orange_logo" src={process.env.PUBLIC_URL + "/icons/favicon.png"} alt="Delegate AI logo"/>
                <h1>Delegate <span className="highlight">AI</span></h1>
                <p>Hey there! For the best MUN experience, please visit us from a desktop.</p>
            </div>
        </>}
        </>
    )
}

export default Home;